export const INPUT_LENGTH = {
  MIN_PASSWORD: 8,
  EMAIL_PIN_NUMBER: 6,
  TEL_PIN_NUMBER: 6,
};
